import * as $ from 'jquery';
import {Global} from '../init-global';
import 'slick-carousel';
import { TweenLite, TimelineLite, Sine, Power2, Power3 } from 'gsap';
const activated = [ TweenLite, TimelineLite, Sine, Power2, Power3 ];


export class ProductsCarousel {

    protected $window: JQuery;
    protected $root: JQuery;
    protected $carouselWrapper: JQuery;
    protected breakpoint:number = 980;
    protected $scrollNext: JQuery;
    protected $scrollPrev: JQuery;
    protected $colourBG: JQuery;
    protected $heading: JQuery;
    protected $footerStrip: JQuery;
    protected twBG:TweenLite;
    protected twLbl:TweenLite;
    protected $productLabel:JQuery;
    protected $viewAll:JQuery;
    protected tlShowBG:TimelineLite;


    constructor(elem: HTMLElement)
    {
        this.$window  = $(<any>window);
        this.$root    = $(elem);
        this.bindUI();
    }

    private bindUI = () => {
        this.$carouselWrapper = $('.c-products-carousel__list', this.$root);
        this.$scrollNext      = $('.u-scroller--right', this.$root);
        this.$scrollPrev      = $('.u-scroller--left', this.$root);
        this.$heading         = $('h2', this.$root);
        this.$footerStrip     = $('.c-products-carousel__label', this.$root);
        this.$viewAll         = $('.c-products-carousel__label-link', this.$footerStrip);
        this.initCarousel();
    }

    private initCarousel = () => {
        this.$carouselWrapper.slick({
          centerMode: false,
          slidesToShow: 6,
          nextArrow: this.$scrollNext,
          prevArrow: this.$scrollPrev,
          variableWidth: true,
          responsive: [
            {
              breakpoint: 980,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '60px',
                slidesToShow: 4
              }
            },
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '60px',
                slidesToShow: 3
              }
            },
            {
              breakpoint: 580,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '60px',
                slidesToShow: 2
              }
            },
            {
              breakpoint: 450,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '50px',
                slidesToShow: 2
              }
            },
            {
              breakpoint: 370,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 2
              }
            }
          ]
        });

        /* UI events 
        */
        this.$carouselWrapper.on({
            mouseenter: (e:any) => {
                if (this.doRollOverEffect()) {
                    this.setRollover(
                        $(e.currentTarget).attr('data-product-colour'), 
                        $(e.currentTarget).attr('data-text-highlight'), 
                        $('.c-products-carousel__title', $(e.currentTarget)).html()
                )}
                e.preventDefault();
            },
            mouseleave: (e:any) => {
                if (this.doRollOverEffect()) {
                    this.killRollover();
                }
                e.preventDefault();
            }
        }, '.c-products-carousel__link');
    }

    private setRollover = (col:string, textHighlight:string, text:string) => {
        //console.log('set rollover');
        this.$heading.css('color', textHighlight);
        if (typeof this.$colourBG == 'undefined') {
            // Create the colour background
            this.$colourBG = $(Global.newTag('div', 'c-products-carousel__bg-colour-panel'));
            this.$root.append(this.$colourBG);
            TweenLite.set(this.$colourBG, { css: { opacity: 0, backgroundColor: col } });

            this.tlShowBG = new TimelineLite( { delay: 0.25 });
            this.tlShowBG.fromTo(this.$colourBG, 0.5, { scale: 0.75 }, { scale: 1, ease: Power3.easeOut })
            .to(this.$colourBG, 0.5, { opacity: 1, ease: Sine.easeOut }, '-=0.5');

        } else {
            if (typeof this.twBG != 'undefined') this.twBG.kill();
            this.twBG = TweenLite.to(this.$colourBG, 0.7, { opacity: 1, scale: 1, backgroundColor: col, ease: Sine.easeInOut });
        }

        if (typeof this.$productLabel == 'undefined') {
            this.$productLabel = $(Global.newTag('span', 'c-products-carousel__product-title'));
            this.$footerStrip.append(this.$productLabel);
            this.$productLabel.hide();
            this.twLbl = TweenLite.to(this.$viewAll, 0.4, { opacity: 0, ease: Sine.easeOut, onComplete: () => {
                this.$productLabel.html(text).css('color', col);
                this.setProductLabel();
            }});
        } else {
            this.$productLabel.css('opacity', 0);
            this.$productLabel.html(text).css('color', col);
            this.setProductLabel();
            this.$viewAll.css('opacity', 0);
            //console.log('set product label' + ' ' + text);
        }

        this.$scrollNext.add(this.$scrollPrev).addClass('u-scroller--white');
    }

    private setProductLabel = () => {
        if (typeof this.twLbl != 'undefined') this.twLbl.kill();
        this.twLbl = TweenLite.fromTo(this.$productLabel, 0.5, { opacity: 0 }, { display: 'block', opacity: 1, ease: Sine.easeOut });
    }

    private killRollover = () => {
        TweenLite.set(this.$heading, { clearProps: 'color' });
        this.$scrollNext.add(this.$scrollPrev).removeClass('u-scroller--white');
 
        if (typeof this.$colourBG != 'undefined') {
            if (typeof this.twBG != 'undefined') this.twBG.kill();
            if (typeof this.tlShowBG != 'undefined') { this.tlShowBG.clear(); this.tlShowBG = undefined; }
            this.twBG = TweenLite.to(this.$colourBG, 0.7, { opacity: 0, ease: Sine.easeOut, onComplete: () => {
                this.$colourBG.remove();
                this.$colourBG = undefined;
                this.twBG = undefined;
            }});
        }
        if (typeof this.$productLabel != 'undefined') {
            if (typeof this.twLbl != 'undefined') this.twLbl.kill();
            this.twLbl = TweenLite.to(this.$productLabel, 0.35, { opacity: 0, ease: Sine.easeOut, onComplete: () => {
                this.$productLabel.remove();
                this.$productLabel = undefined;
                this.twLbl = TweenLite.to(this.$viewAll, 0.6, { opacity: 1, ease: Sine.easeOut, onComplete: () => {
                    TweenLite.set(this.$viewAll, { clearProps: 'all'});
                    this.twLbl = undefined;
                }});
            }});
        }
    }

    private doRollOverEffect = () => {
        return (Global.getViewport().width >= this.breakpoint);
    }
}